
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "submenu",
  components: {

  },
  computed: {

  },
})
export default class extends Vue {

}
